import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

export interface UpgradeModalData {
  featureName: string;
  currentVersion: string;
  newVersion: string;
  baseUrl: string;
}

@Injectable({
  providedIn: "root",
})
export class UpgradeModalService {
  private isVisibleSubject = new BehaviorSubject<boolean>(false);
  private dataSubject = new BehaviorSubject<UpgradeModalData | null>(null);
  private isUpgradingSubject = new BehaviorSubject<boolean>(false);
  private resultSubject = new BehaviorSubject<{
    action: string;
    success?: boolean;
  } | null>(null);

  public isVisible$ = this.isVisibleSubject.asObservable();
  public data$ = this.dataSubject.asObservable();
  public isUpgrading$ = this.isUpgradingSubject.asObservable();

  show(data: UpgradeModalData): Promise<{ action: string; success?: boolean }> {
    this.dataSubject.next(data);
    this.isVisibleSubject.next(true);
    this.resultSubject.next(null);

    return new Promise((resolve) => {
      const subscription = this.resultSubject.subscribe((result) => {
        if (result !== null) {
          subscription.unsubscribe();
          resolve(result);
        }
      });
    });
  }

  hide() {
    this.isVisibleSubject.next(false);
    this.isUpgradingSubject.next(false);
  }

  setUpgrading(isUpgrading: boolean) {
    this.isUpgradingSubject.next(isUpgrading);
  }

  accept(success: boolean = true) {
    this.resultSubject.next({ action: "accept", success });
    this.hide();
  }

  dismiss() {
    this.resultSubject.next({ action: "later" });
    this.hide();
  }
}
